import {
  collectRoutines,
  dispatchAction,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import { tap, withLatestFrom } from 'rxjs';
import { loadedCurrentUser$ } from 'streams/currentUser/currentUser$';
import {
  saveViewSettingsChange,
  viewpointModeViewSettingsUpdateRequested,
  workspaceModeViewSettingsUpdateRequested,
} from './actions';
import { viewSettingsApi } from '@ardoq/api';
import { isPresentationMode } from 'env';
import { updateViewSettings } from '@ardoq/view-settings';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { isViewpointModeView, isWorkspaceModeView } from './utils';
import { updateCurrentUser } from '../../../streams/currentUser/actions';

const saveViewSettings = routine(
  ofType(saveViewSettingsChange),
  extractPayload(),
  withLatestFrom(loadedCurrentUser$),
  tap(
    async ([
      { contextId, viewId, modifiedViewSettings },
      { _id: currentUserId },
    ]) => {
      if (isPresentationMode() || !currentUserId) {
        return;
      }

      // save the settings for the current user
      await viewSettingsApi.updateViewSettingsForView({
        contextId,
        viewId,
        userId: currentUserId,
        settings: modifiedViewSettings,
      });

      // Re-fetch current user as updating view settings changes _version
      dispatchAction(updateCurrentUser());
    }
  )
);

// #region Backwards compatibility layer
/**
 * The below code is needed to facilitate the gradual transition towards the new stream architecture.
 *
 * While the view settings subscriptions are namespaced by view instance ids, the actions that update
 * the view settings are not namespaced. To remove the compatibility layer, replace the updateViewSettings
 * actions with viewpointModeViewSettingsUpdateRequested | workspaceModeViewSettingsUpdateRequested
 */

const backwardsCompatibilityLayer = routine(
  ofType(updateViewSettings),
  extractPayload(),
  withLatestFrom(isViewpointMode$),
  tap(
    ([{ viewId, settings, persistent, settingsPath }, { isViewpointMode }]) => {
      if (isViewpointMode && isViewpointModeView(viewId)) {
        dispatchAction(
          viewpointModeViewSettingsUpdateRequested({
            viewId,
            settings,
            persistent,
            settingsPath,
          })
        );
      } else if (isWorkspaceModeView(viewId)) {
        dispatchAction(
          workspaceModeViewSettingsUpdateRequested({
            viewId,
            settings,
            persistent,
            settingsPath,
          })
        );
      }
    }
  )
);

// #endregion Backwards compatibility layer

export const routines = collectRoutines(
  saveViewSettings,
  backwardsCompatibilityLayer
);
